export default __webpack_public_path__ + "static/media/unmute.9f13e566.svg";